import React, { useEffect, useRef } from 'react'
import * as Blockly from 'blockly'
import { ensureBlocklySetup } from './blocklySetup'

interface BlocklyReadOnlyDisplayProps {
  xml: string
  height?: number
}

export function BlocklyReadOnlyDisplay({ xml, height = 250 }: BlocklyReadOnlyDisplayProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const workspaceRef = useRef<Blockly.WorkspaceSvg | null>(null)

  useEffect(() => {
    if (!containerRef.current) return

    ensureBlocklySetup()

    const workspace = Blockly.inject(containerRef.current, {
      readOnly: true,
      scrollbars: false,
      trashcan: false,
      zoom: { controls: false, wheel: false, startScale: 1.0 },
      grid: undefined,
      move: { scrollbars: false, drag: false, wheel: false },
    })

    workspaceRef.current = workspace

    try {
      const dom = Blockly.utils.xml.textToDom(xml)
      Blockly.Xml.domToWorkspace(dom, workspace)
    } catch {
      // ignore malformed xml
    }

    // Zoom to fit after blocks are rendered
    workspace.zoomToFit()
    // Scale down slightly so blocks aren't edge-to-edge
    const currentScale = workspace.getScale()
    workspace.setScale(Math.min(currentScale, 0.85))
    workspace.scrollCenter()

    return () => {
      workspace.dispose()
      workspaceRef.current = null
    }
  }, [xml])

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
        height,
        borderRadius: '8px',
        overflow: 'hidden',
      }}
    />
  )
}
